import { AIReportCtaPlacement, AIReportCtaSection } from "app/components/ai-reports-cta-section/AIReportCtaSection";
import EducationContainerProminentBig from "app/components/educationbar/educationContainerProminentBig";
import { MarketingChannelsDistribution } from "app/components/React/MarketingChannelsDistribution/MarketingChannelsDistribution";
import { WebsiteHeaderReact } from "app/components/website-header/WebsiteHeaderReact";
import { WWOAllTrafficChannelsOverviewBarChartContainerDS } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelsOverviewBarChart/WWOAllTrafficChannelsOverviewBarChartContainerDS";
import TotalVisitsComponentsContainer from "app/pages/website-analysis/TrafficAndEngagement/Components/single/TotalVisitsComponentsContainer";
import { EngagementOverviewKpiContainerDS } from "app/pages/website-performance/components/EngagementOverviewKpi/EngagementOverviewKpiContainerDS";
import { WWOSearchTrafficOrganicContainerDS } from "app/pages/website-performance/components/SearchTraffic/organic/WWOSearchTrafficOrganicContainerDS";
import { WWOSearchTrafficPaidContainerDS } from "app/pages/website-performance/components/SearchTraffic/paid/WWOSearchTrafficPaidContainerDS";
import { SectionHeader } from "app/pages/website-performance/components/SectionHeader";
import { WWOSocialOverviewContainerDS } from "app/pages/website-performance/components/SocialOverview/WWOSocialOverviewContainerDS";
import { WWOTopAdDestinationsContainerDS } from "app/pages/website-performance/components/TopAdDestinations/WWOTopAdDestinationsContainerDS";
import { WWOTrafficTopCountriesContainerDS } from "app/pages/website-performance/components/TopCountries/WWOTrafficTopCountriesContainerDS";
import { WWOTopLinkDestinationsContainerDS } from "app/pages/website-performance/components/TopLinkDestinations/WWOTopLinkDestinationsContainerDS";
import { WWOTopPublishersTableContainerDS } from "app/pages/website-performance/components/TopPublishers/WWOTopPublishersTableContainerDS";
import { WWOTopReferringIndustriesContainerDS } from "app/pages/website-performance/components/TopReferringIndustries/WWOTopReferringIndustriesContainerDS";
import { WWOTopReferringWebsitesContainerDS } from "app/pages/website-performance/components/TopReferringWebsites/WWOTopReferringWebsitesContainerDS";
import { WWOTrafficVisitsOverTimeContainerDS } from "app/pages/website-performance/components/TrafficVisitsOverTime/WWOTrafficVisitsOverTimeContainerDS";
import {
    AICtaSectionWrapper,
    FullWidthWrapper,
    HeaderWithChannelWrapper,
    RowWrapper,
    SearchTrafficWrapper,
    SectionHeaderWrapper,
    TwoInARowWrapper,
} from "app/pages/website-performance/StyledComponents";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const DigitalSuiteWorldwideOverview = () => {
    return (
        <>
            <EducationContainerProminentBig />
            <div className="row-fluid">
                <div className="wwo-widgets">
                    <RowWrapper className="row-flex">
                        <FullWidthWrapper className="webkit-overflow">
                            <WebsiteHeaderReact />
                        </FullWidthWrapper>
                        <SectionHeaderWrapper>
                            <SectionHeader sectionTitleKey="wa.wwo.section.webaudience.title" />
                        </SectionHeaderWrapper>
                        <TotalVisitsComponentsContainer />

                        <FullWidthWrapper>
                            <EngagementOverviewKpiContainerDS />
                        </FullWidthWrapper>

                        <AICtaSectionWrapper>
                            <AIReportCtaSection placement={AIReportCtaPlacement.PERFORMANCE} />
                        </AICtaSectionWrapper>
                    </RowWrapper>
                    <RowWrapper className="row-flex pdf-page">
                        <FullWidthWrapper>
                            <WWOTrafficVisitsOverTimeContainerDS />
                        </FullWidthWrapper>
                    </RowWrapper>
                    <RowWrapper className="row-flex pdf-page">
                        <SectionHeaderWrapper>
                            <SectionHeader sectionTitleKey="wa.wwo.section.geo.title" />
                        </SectionHeaderWrapper>
                    </RowWrapper>
                    <FullWidthWrapper>
                        <WWOTrafficTopCountriesContainerDS />
                    </FullWidthWrapper>

                    <RowWrapper className="row-flex pdf-page">
                        <SectionHeaderWrapper>
                            <SectionHeader sectionTitleKey="wa.wwo.section.marketingmix.title" />
                        </SectionHeaderWrapper>
                        <WWOAllTrafficChannelsOverviewBarChartContainerDS />
                    </RowWrapper>

                    <RowWrapper className="row-flex pdf-page">
                        <HeaderWithChannelWrapper>
                            <SectionHeader sectionTitleKey="wwo.search.traffic.organic.section.title" />
                            <MarketingChannelsDistribution marketingChannelsType={4} />
                        </HeaderWithChannelWrapper>
                        <SearchTrafficWrapper>
                            <WWOSearchTrafficOrganicContainerDS />
                        </SearchTrafficWrapper>
                    </RowWrapper>

                    <RowWrapper className="row-flex pdf-page">
                        <HeaderWithChannelWrapper>
                            <SectionHeader sectionTitleKey="wwo.search.traffic.paid.section.title" />
                            <MarketingChannelsDistribution marketingChannelsType={5} />
                        </HeaderWithChannelWrapper>
                        <SearchTrafficWrapper>
                            <WWOSearchTrafficPaidContainerDS />
                        </SearchTrafficWrapper>

                        <HeaderWithChannelWrapper>
                            <SectionHeader sectionTitleKey="analysis.sources.referrals.title" />
                            <MarketingChannelsDistribution marketingChannelsType={2} />
                        </HeaderWithChannelWrapper>
                        <TwoInARowWrapper>
                            <WWOTopReferringWebsitesContainerDS />
                            <WWOTopReferringIndustriesContainerDS />
                        </TwoInARowWrapper>

                        <TwoInARowWrapper>
                            <FlexColumn>
                                <SectionHeaderWrapper>
                                    <SectionHeader sectionTitleKey="analysis.destination.out.title" />
                                </SectionHeaderWrapper>
                                <WWOTopLinkDestinationsContainerDS />
                            </FlexColumn>
                            <FlexColumn>
                                <SectionHeaderWrapper>
                                    <SectionHeader sectionTitleKey="analysis.destination.paidout.title" />
                                </SectionHeaderWrapper>
                                <WWOTopAdDestinationsContainerDS />
                            </FlexColumn>
                        </TwoInARowWrapper>
                    </RowWrapper>

                    <RowWrapper className="row-flex pdf-page">
                        <HeaderWithChannelWrapper>
                            <SectionHeader sectionTitleKey="analysis.sources.social.title" />
                            <MarketingChannelsDistribution marketingChannelsType={3} />
                        </HeaderWithChannelWrapper>
                        <FullWidthWrapper>
                            <WWOSocialOverviewContainerDS />
                        </FullWidthWrapper>
                    </RowWrapper>

                    <RowWrapper className="row-flex pdf-page">
                        <HeaderWithChannelWrapper>
                            <SectionHeader sectionTitleKey="wa.wwo.section.displayads.title" />
                            <MarketingChannelsDistribution marketingChannelsType={6} />
                        </HeaderWithChannelWrapper>
                        <FullWidthWrapper>
                            <WWOTopPublishersTableContainerDS />
                        </FullWidthWrapper>
                    </RowWrapper>
                </div>
            </div>
        </>
    );
};
